module.exports = __webpack_public_path__ + "static/media/arrowDown.7f5a8c9b.svg";